import { useContext, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { DateTime } from "luxon"
import { toast } from "react-toastify"
import { profileContext } from "../providers/profile.provider"
import { schoolContext } from "../providers/school.provider"
import { lessonsContext } from "../providers/lessons.provider"
import { getLessonByID } from "../utils/firestore.utils"

// L'indirizzo di una lezione sola, `/lessons/:lessonID`: è il link
// nell'evento del calendario (src/utils/calendar.utils.js). Apre l'app sul
// giorno della lezione, nel suo circolo, con la lezione aperta e sotto gli
// occhi, come quando la si tocca nella settimana. Poi l'indirizzo torna
// quello delle lezioni: tornare indietro non deve riaprirla.
//
// Si aspetta che i circoli siano letti: scegliere il circolo prima vorrebbe
// dire vederselo cambiare sotto dalla scelta iniziale.
export default function useLessonLink() {
	const { lessonID } = useParams()
	const navigate = useNavigate()
	const { coach, setDisplayedCoachID } = useContext(profileContext)
	const { loading: schoolsLoading, schools, setSelectedSchool } = useContext(schoolContext)
	const { setSelectedDate, setLessonsView, setLessonToOpen } = useContext(lessonsContext)

	const isReady = Boolean(lessonID && coach && !schoolsLoading)

	useEffect(() => {
		if (!isReady) return
		let isCurrent = true

		const notFound = () =>
			toast.error("Questa lezione non c'è più", {
				toastId: "lessonLink",
				position: "top-center",
			})

		getLessonByID(lessonID)
			.then(lesson => {
				if (!isCurrent) return
				navigate("/lessons", { replace: true })
				const start = lesson?.lessonStart?.toDate?.()
				// eliminata, o di un circolo che non è più il suo
				if (!lesson || !start || !schools[lesson.schoolID]) return notFound()

				setSelectedSchool(lesson.schoolID)
				// è sua, da titolare o da assistente: le sue lezioni, non quelle
				// di un collega che stava guardando
				setDisplayedCoachID(coach.coachID)
				setSelectedDate(DateTime.fromJSDate(start).toISODate())
				setLessonsView("day")
				setLessonToOpen(`${lesson.coachID}_${lesson.lessonID}`)
			})
			.catch(error => {
				if (!isCurrent) return
				console.error("Lezione dal link non letta:", error)
				navigate("/lessons", { replace: true })
				toast.error("Non sono riuscito ad aprire la lezione", {
					toastId: "lessonLink",
					position: "top-center",
				})
			})

		return () => {
			isCurrent = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isReady, lessonID])
}
